import { useHeader } from '@telecom/shared/composables/use-header';

/**
 * 根据部署环境获取 Eureka 基础 URL
 * @param siteRegion 站点区域 ('CN' | 'EU' | 'US')
 * @returns Eureka 基础 URL
 */
function getEurekaBaseUrl(siteRegion?: string): string {
    switch (siteRegion) {
    case 'CN':
        return 'https://eureka.zhihuiya.com';
    case 'EU':
        return 'https://eureka.patsnap.eu';
    case 'US':
    default:
        return 'https://eureka.patsnap.com';
    }
}

/**
 * 根据部署环境和文献类型生成文献 URL
 */
export function useLiteratureUrl() {
    const { headerService } = useHeader();

    /**
     * 根据部署环境生成文献 URL
     * @param docId 文献 ID
     * @param docType 文献类型 ('paper' | 'website')
     * @param fallbackUrl 备用 URL（如果提供）
     * @returns 完整的文献 URL
     */
    function buildLiteratureUrl(docId: string, docType?: string, fallbackUrl?: string): string {
        // 如果是 website 类型，使用原始 URL
        if (docType === 'website' && fallbackUrl) {
            return fallbackUrl;
        }
        // 对于 paper 类型，根据部署环境拼装 URL
        const siteRegion = headerService.account?.siteRegion;
        const baseUrl = getEurekaBaseUrl(siteRegion);

        const paperUrl = `${baseUrl}/literature/#/?paperId=${docId}`;
        return fallbackUrl || paperUrl;
    }

    return {
        buildLiteratureUrl,
    };
}

/**
 * 根据部署环境和文献 ID 生成文献 URL（非 Vue composable 版本）
 * @param docId 文献 ID
 * @param siteRegion 站点区域
 * @returns 完整的文献 URL
 */
export function buildLiteratureUrlWithRegion(docId: string, siteRegion?: string): string {
    const baseUrl = getEurekaBaseUrl(siteRegion);
    return `${baseUrl}/literature/#/?paperId=${docId}`;
}
